import style from './index.module.less'

import React, { forwardRef, useEffect, useImperativeHandle, useState, useReducer } from "react";
import {Image} from 'antd'
const ImagePreview = () => {
    const [visible, setVisible] = useState(false);
    const [url, setUrl] = useState<string>('')

    //@ts-ignore
    useEffect(() => {
        window.GpreviewImg = (src: string) => {
            setUrl(src)
            setVisible(true);

        }
        return () => {
            delete window['GpreviewImg']
        }
    }, [])
    
    return (
        <Image
            width={200}
            style={{ display: 'none'}}
            src={url}
            // wrapperStyle={{zIndex:'2004',position:'absolute',width:'100%',height:'100%'}}
            preview={{
                visible,
                src: url,
                onVisibleChange: (value) => {
                  setVisible(value);
                  setTimeout(()=>{
                      window.isNoteImagePreview = value;
                  },600)

                }
            }}
        />
    )
}
export default ImagePreview